




















































import { Component, Prop, Vue } from "vue-property-decorator";
import states from '../../assets/states';
@Component
export default class InvoiceViewerDelivery extends Vue{
    @Prop() delivery: any;
    state = '';
    city = '';
    DeliveryType = [
        'در محل فروشگاه',
        'درب منزل مشتری',
        'توسط واسطه',
    ];
    mounted () {
        if (this.delivery.address?.location) {
            const state = (states as any)[''+this.delivery.address.location.stateId];
         this.state = state?.name;
         this.city = state?.cities[''+this.delivery.address.location.cityId];
        }
    }
}
